var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegnfineSearc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 1.5,
    stroke: "#F7F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6095 18.7241L17.2248 15.3394C17.9241 14.2854 18.3335 13.0234 18.3335 11.6667C18.3335 7.9907 15.3428 5 11.6667 5C7.9907 5 5 7.9907 5 11.6667C5 15.3428 7.9907 18.3335 11.6667 18.3335C13.0234 18.3335 14.2854 17.9241 15.3394 17.2248L18.7241 20.6095C19.2442 21.1302 20.0895 21.1302 20.6095 20.6095C21.1302 20.0888 21.1302 19.2448 20.6095 18.7241ZM7.00002 11.6667C7.00002 9.09338 9.09338 7.00002 11.6667 7.00002C14.2401 7.00002 16.3335 9.09338 16.3335 11.6667C16.3335 14.2401 14.2401 16.3335 11.6667 16.3335C9.09338 16.3335 7.00002 14.2401 7.00002 11.6667Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegnfineSearc);
export default __webpack_public_path__ + "static/media/megnfineSearc.e0bebc8e80571a54b12a149674308bd9.svg";
export { ForwardRef as ReactComponent };